import CarouselItem from './src/carousel-item';

CarouselItem.install = function(Vue) {
  Vue.component(CarouselItem.name, CarouselItem);
};

export default CarouselItem;



// WEBPACK FOOTER //
// ./src/components/carousel-item/index.js